export enum OrderStatus {
  OPEN = 'Open', PENDING_REVIEW = 'Pending Review', PENDING_APPROVAL = 'Pending Approval', COMPLETED = 'Completed', CANCELED = 'Canceled', ON_HOLD = 'On Hold'
}

export const getStatus = (value: string): string | undefined => {
  return Object.keys(OrderStatus).find((key) => OrderStatus[key as keyof typeof OrderStatus] === value);
}